import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import Chart from "react-apexcharts";
import { colors } from "../../../../theme";

const StyledCard = styled(Card)`
  flex: 1;
  width: auto;
  background-color: #1E1E1E;
  background-image: none;
  border-radius: 15px;
  /* border: 3px solid #449095; */
`;



export const InfoCard = ({ ip, location }) => {
  return (
    <div style={{ width: '100%' }}>
      <StyledCard>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h3" sx={{ fontWeight: 600 }}>IP :</Typography>
            <Typography variant="h3" sx={{ fontWeight: 900, }}>{ip}</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 600 }} >Location: </Typography>
            <Typography variant="h5" sx={{ fontWeight: 900 }}>{location}</Typography>
          </Box>
        </CardContent>
      </StyledCard>
    </div>
  )
}

export const RadialBarGeneral = ({ count_malware, count_url, count_dns }) => {

  const series = [count_malware, count_url, count_dns]


  const options = {
    "annotations": {},
    "chart": {
      "animations": {
        "enabled": false
      },
      "foreColor": "#373D3F",
      "fontFamily": "Roboto",
      "height": 260,
      "toolbar": {

      },
      "type": "donut",
      "width": 328,
    },
    "plotOptions": {
      "bar": {
        "borderRadius": 10,
        "borderRadiusApplication": "end",
        "borderRadiusWhenStacked": "last",
        "hideZeroBarsWhenGrouped": false,
        "isDumbbell": false,
        "isFunnel": false,
        "isFunnel3d": true,
        "dataLabels": {
          "total": {
            "enabled": false,
            "offsetX": 0,
            "offsetY": 0,
            "style": {
              "color": "#373d3f",
              "fontSize": "12px",
              "fontWeight": 600
            }
          }
        }
      },
      "bubble": {
        "zScaling": true
      },
      "treemap": {
        "dataLabels": {
          "format": "scale"
        }
      },
      "radialBar": {
        "hollow": {
          "background": "#fff"
        },
        "dataLabels": {
          "name": {},
          "value": {},
          "total": {}
        }
      },
      "pie": {
        "startAngle": 0,
        "donut": {
          "size": "61%",
          "labels": {
            "name": {},
            "value": {
              "fontSize": 76,
              "fontWeight": 500
            },
            "total": {}
          }
        }
      }
    },
    "colors": [
      "#791F2A",
      "#E7D763",
      "#68BBBC",
    ],
    "dataLabels": {
      "enabled": false,
    },
    "fill": {
      "opacity": 1
    },
    "grid": {
      "padding": {
        "right": 0,
        "bottom": 12,
        "left": 10
      }
    },
    "labels": [
      "Count MALWARE",
      "Count URL",
      "Count Passive DNS",
    ],
    "legend": {
      "floating": false,
      "class": "chart-toolbar",
      "fontSize": 8,
      "itemMargin": {
        "horizontal": 0,
        "vertical": 0
      }
    },
    "stroke": {
      "show": false,
      "fill": {
        "type": "solid",
        "opacity": 0.85,
        "gradient": {
          "shade": "dark",
          "type": "horizontal",
          "shadeIntensity": 0.5,
          "inverseColors": true,
          "opacityFrom": 1,
          "opacityTo": 1,
          "stops": [
            0,
            50,
            100
          ],
          "colorStops": []
        }
      }
    },
    "tooltip": {
      "fillSeriesColor": true
    },
    "xaxis": {
      "labels": {
        "trim": true,
        "style": {}
      },
      "group": {
        "groups": [],
        "style": {
          "colors": [],
          "fontSize": "12px",
          "fontWeight": 400,
          "cssClass": ""
        }
      },
      "title": {
        "style": {
          "fontWeight": 700
        }
      }
    },
    "yaxis": {
      "labels": {
        "style": {}
      },
      "title": {
        "style": {
          "fontWeight": 700
        }
      }
    },
    "theme": {
      "palette": "palette 2"
    }

  }

  return (
    <Box>
      <Chart options={options && options} series={series && series} type='donut' />
    </Box>
  )
}


export const MalwareList = ({ malware }) => {

  return (
    <>
      {malware &&
        malware.map(mal => (
          <Grid
            display="flex"
            alignItems="center"
            borderBottom={`1px solid #eaeaea`}
            p="15px"
          >
            <Grid sx={{
              alignItems: 'left'
            }}>
              <Typography
                variant="h5"
                fontWeight="900"
                fontSize="14"
                style={{ textAlign: "center" }}
                color='white'
                sx={{
                  width: { lg: "40vh", xs: "100%" },
                  justifyContent: 'left',
                  marginRight: { xs: "30%", md: "" }
                }}
              >
                {mal.date}
              </Typography>
            </Grid>
            <Grid
              sx={{ width: "80vh", marginLeft: { md: "80px", xs: "20%" }, justifyContent: 'left' }}
            >
              <Typography
                color='white'
                style={{ fontWeight: 900, fontSize: 14, cursor: "pointer", justifyContent: 'left' }}
              >
                {mal.idMalware}
              </Typography>
            </Grid>
          </Grid>
        ))
      }
    </>
  )
}
export const PassiveDNSList = ({ passiveDns }) => {


  return (
    <>
      {passiveDns &&
        passiveDns.map(dns => (
          <Grid
            display="flex"
            alignItems="center"
            borderBottom={`1px solid #eaeaea`}
            p="15px"
          >
            <Box sx={{
              justifyContent: 'center'
            }}>
              <Typography
                variant="h5"
                fontWeight="900"
                fontSize="14"
                style={{ textAlign: "center" }}
                color='white'
                sx={{
                  width: { lg: "40vh", xs: "100%" },
                  justifyContent: 'left'
                }}
              >
                {dns.last}
              </Typography>
            </Box>
            <Box
              sx={{ width: "80vh", marginLeft: { md: "80px", xs: "22%" }, justifyContent: 'left' }}
            >
              <Typography
                color='white'
                style={{ fontWeight: 900, fontSize: 14, cursor: "pointer", justifyContent: 'left' }}
              >
                {dns.hostname}
              </Typography>
            </Box>
          </Grid>
        ))
      }
    </>
  )
}
export const URLList = ({ urlList }) => {


  return (
    <>
      {urlList &&
        urlList.map(url => (
          <Grid
            display="flex"
            salignItems="center"
            borderBottom={`1px solid #eaeaea`}
            colors={colors.grey[100]}
            p="15px"
          >
            <Grid sx={{
              alignItems: 'center'
            }}>
              <Typography
                variant="h5"
                fontWeight="900"
                fontSize="14"
                style={{ textAlign: "center" }}
                color='white'
                sx={{
                  width: { lg: "40vh", xs: "100%" },
                  marginLeft: { xs: "10%", md: "80px" }, justifyContent: 'left'
                }}
              >
                {url.date}
              </Typography>
            </Grid>
            <Grid
              sx={{ width: { md: "80vh", xs: "80%" }, marginLeft: { xs: "22%", md: "80px" }, justifyContent: 'left' }}
            >
              <Typography
                color='white'
                style={{ fontWeight: 900, fontSize: 14, cursor: "pointer", justifyContent: 'left' }}
              >
                {url.url}
              </Typography>
            </Grid>
          </Grid>
        ))
      }
    </>
  )
}